/** Public Seller Program marketing site */
export const SELLER_PROGRAM_PATH = '/seller-program';
export const SELLER_APPLY_PATH = '/seller-program/apply';

/** Authenticated seller studio + onboarding */
export const SELLER_ONBOARDING_PATH = '/seller/onboarding';

export const SELLER_PATHS = {
  dashboard: '/seller/dashboard',
  designs: '/seller/designs',
  orders: '/seller/orders',
  earnings: '/seller/earnings',
  store: '/seller/store',
  settings: '/seller/settings',
} as const;

export function resolveSellerStudioPath(onboardingComplete?: boolean | null): string {
  if (onboardingComplete === false) return SELLER_ONBOARDING_PATH;
  return SELLER_PATHS.dashboard;
}

export function isSellerProgramFlowPath(pathname: string): boolean {
  return (
    pathname === SELLER_PROGRAM_PATH ||
    pathname.startsWith(`${SELLER_PROGRAM_PATH}/`)
  );
}
